import NextLink, { type LinkProps } from 'next/link';
import type { AnchorHTMLAttributes, Ref } from 'react';

export type AppLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  LinkProps & {
    children?: React.ReactNode;
    ref?: Ref<HTMLAnchorElement>;
  };

export const AppLink = ({ ref, ...props }: AppLinkProps) => (
  <NextLink {...props} ref={ref} />
);
